import * as React from 'react'

import AlertBox from '@envato/foundation-alert-box'
import Button from '../../button'

import * as styles from './tcBanner.module.css'

/*
 Url comes from https://github.com/envato/marketplace/blob/master/app/presenters/system_banner/terms_and_conditions_updates_presenter.rb#L19
*/
const MORE_INFO_URL =
  'https://forums.envato.com/t/important-terms-updates-for-all-users-on-envato-market/22441'

export interface IProps {
  acceptedCurrentTerms?: boolean
  isAuthor?: boolean
  onConfirm: () => void
}

const TcBanner = ({ acceptedCurrentTerms, isAuthor, onConfirm }: IProps) => {
  if (acceptedCurrentTerms === false) {
    return (
      <div className={styles.root}>
        <AlertBox
          dismissRender={() => (
            <Button primary onClick={onConfirm}>
              Thanks. I got it.
            </Button>
          )}
        >
          Please read through the&nbsp;
          <a target="_blank" href="/legal/market" rel="noopener noreferrer">
            Envato Market Terms
          </a>{' '}
          &nbsp;
          {isAuthor ? (
            <span>
              and{' '}
              <a target="_blank" href="/legal/author" rel="noopener noreferrer">
                Author Terms
              </a>{' '}
            </span>
          ) : null}
          because they&apos;ve changed. More info &nbsp;
          <a target="_blank" rel="noopener noreferrer" href={MORE_INFO_URL}>
            here
          </a>
          .
        </AlertBox>
      </div>
    )
  }

  return null
}

export default TcBanner
